import { useContext } from "react";

import { SalesPageV3NextContext } from "./sales-v3-next-provider";

export const useSalesPageV3NextContext = () => {
  const context = useContext(SalesPageV3NextContext);

  if (!context) {
    throw new Error(
      "useSalesPageV3NextContext can only be used inside SalesV3NextProvider",
    );
  }

  return context;
};
